import { SUPPORTED_LOCALES, type SupportedLocaleType } from '@repo/web-chrome/i18n';

const LOCALE_SET = new Set<string>(SUPPORTED_LOCALES);

export function stripLocalePrefix(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) {
    return '/';
  }
  const first = segments[0];
  if (first && LOCALE_SET.has(first as SupportedLocaleType)) {
    return `/${segments.slice(1).join('/')}` || '/';
  }
  return pathname;
}
